import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
// utils
import { PURGE } from 'redux-persist';
import { saltmineJwtHeaders, urls } from 'src/libs/reqConf';
import { errorHandle } from 'src/utils/function';
import { getCloseLoading, getLoading } from './loading';
import { getOpen, setError } from './modal';
// ----------------------------------------------------------------------
// 네트워크 기관
const initialState = {
  isLoading: false,
  notificationList: { docs: [], total: 0, page: 1, pages: 1, limit: 10 },
  notificationSetting: {},
  pickAlram: {}
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    notificationReset(state) {
      // immer를 사용하여 직접 상태를 수정
      Object.assign(state, initialState);
    },
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // GET NOTICES
    readNotificationListSuccess(state, action) {
      state.isLoading = false;

      // 새로 들어온 estimates 중에 state.estimates에 없는 것만 필터링
      const newNotificationList = action.payload?.docs.filter(
        (newNotification) =>
          !state.notificationList.docs.some((notification) => notification._id === newNotification._id)
      );

      if (action.payload.page === 1) {
        // 첫 페이지일 경우, 전체 데이터를 덮어씀
        state.notificationList = action.payload;
      } else {
        // 새로 들어온 docs를 기존 docs와 병합 (중복 제거 로직 필요 시 적용)
        const updatedDocs = [...state.notificationList.docs, ...newNotificationList];

        state.notificationList = { ...state.notificationList, docs: [...updatedDocs] };
      }
    },
    readNotificationSuccess(state, action) {
      state.notificationList.docs.forEach((notification) => {
        if (notification?._id === action?.payload?._id) {
          notification.isRead = true;
        }
      });
    },

    // GET 알림설정 조회
    getNotificationSetting(state, action) {
      state.isLoading = false;
      state.notificationSetting = action.payload;
    },

    extraReducers: (builder) => {
      builder.addCase(PURGE, () => initialState);
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openModal, closeModal, readNotificationListSuccess, notificationReset } = slice.actions;

// ----------------------------------------------------------------------

// 알림 목록 불러오기
export function readNotificationList(params) {
  const { page = 1, limit = 20 } = params || {};

  return async (dispatch) => {
    let accessToken = window.localStorage.getItem('accessToken');
    dispatch(slice.actions.startLoading());
    try {
      const url = `${urls.notification}/paginate?page=${page}&limit=${limit}&target=notice,event,quoteRelation`;

      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);

      dispatch(slice.actions.readNotificationListSuccess(response?.data?.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
// 알림 읽음
export function readNotication(noticationId) {
  return async (dispatch) => {
    let accessToken = window.localStorage.getItem('accessToken');
    dispatch(getLoading());
    try {
      const url = `${urls.notification}/${noticationId}?autoMarkRead=true`;

      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);
      dispatch(slice.actions.readNotificationSuccess(response.data.data));

      return response.data.status;
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------

// 알림설정 조회
export function getNotificationSetting() {
  return async (dispatch) => {
    try {
      const url = `${urls.account}/setting/notification?type=notice,event,banner,review,chat`;
      let accessToken = window.localStorage.getItem('accessToken');
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);
      dispatch(slice.actions.getNotificationSetting(response.data.data));
      return response.data.status;
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ---------------------------------------------------------------------

// 알림설정 수정
export function patchNotificationSetting(params) {
  return async (dispatch) => {
    try {
      const url = `${urls.account}/setting/notification/notice,event,banner,review,chat`;
      let accessToken = window.localStorage.getItem('accessToken');
      const body = params;
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.patch(url, body, config);
      dispatch(slice.actions.getNotificationSetting(response.data.data));
      return response.data.status;
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}
